/**
 * 盤情報APIサービス
 * バックエンドAPIと通信して盤情報を取得
 */

import { apiClient } from '@/shared/lib/axios';

/**
 * 盤基本情報
 */
export interface PanelBasicInfo {
  readonly id: number;
  readonly panelName: string;
  readonly status: 'NORMAL' | 'STOPPED' | 'ERROR' | null;
}

/**
 * 盤一覧取得レスポンス
 */
interface GetAllPanelsResponse {
  readonly success: boolean;
  readonly panels: readonly PanelBasicInfo[];
}

/**
 * 全盤の基本情報を取得
 */
export const getAllPanels = async (): Promise<readonly PanelBasicInfo[]> => {
  const response = await apiClient.get<GetAllPanelsResponse>('/api/panels');

  if (!response.data.success) {
    throw new Error('盤一覧の取得に失敗しました');
  }

  return response.data.panels;
};
